import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Layout from "@/components/feature/Layout";
import Services from "@/pages/services/page";
import Contact from "@/pages/contact/page";
import Privacy from "@/pages/privacy/page";
import Terms from "@/pages/terms/page";
import Cookie from "@/pages/cookie/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/services",
        element: <Services />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/privacy",
        element: <Privacy />,
      },
      {
        path: "/terms",
        element: <Terms />,
      },
      {
        path: "/cookie",
        element: <Cookie />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;